module.exports = __webpack_public_path__ + "static/media/wordpress.e08e61be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/wordpress.svg
// module id = 260
// module chunks = 0